import React, { useEffect, useState } from 'react';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { MARKETPLACE_PRE_APPROVED_BANNER } from 'types/morph.pagePosition.constants';
import MarketplacePreApprovedBannerView from './MarketplacePreApprovedBannerView';
import { useMarketplacePreApprovedBanner } from './hooks/MarketplacePreApprovedBanner.hook';
import { useFlag } from 'hook/flag.hook';
import { isVariationActive } from 'helpers/optimizely.helper';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';

const MarketplacePreApprovedBannerController = props => {
  const { modulePosition } = props;
  const atr = getViewModuleTrackingAttributes({
    pagePosition: MARKETPLACE_PRE_APPROVED_BANNER,
    modulePosition: modulePosition,
    vertical: CREDIT_CARD_VERTICAL,
  });

  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);
  const hasApproved = props?.creditCards?.some(
    obj => obj?.preApproved === true,
  );
  const [showBanner, setShowBanner] = useState(false);
  const { onLinkClick } = useMarketplacePreApprovedBanner(props, showBanner);

  useEffect(() => {
    setShowBanner(hasApproved);
  }, [hasApproved]);

  const handleLinkClick = () => {
    setShowBanner(false);
    onLinkClick();
  };

  // show or not show the view logic was included here in order
  // to keep it for the module itself..
  // waiting for SLAPI changes when this will be normalized.

  if (showBanner) {
    return (
      <MarketplacePreApprovedBannerView
        seenPixel={seenPixel}
        onLinkClick={handleLinkClick}
        bannerTitle={'Congrats, your highest approval odds are here'}
      />
    );
  }

  return '';
};

export default MarketplacePreApprovedBannerController;
